/**
 * FileUploadReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * FileUploadReq
 */
export interface FileUploadReq {
  /** 文件 */
  file: any
}

/**
 * FileUploadReq Schema
 */
export const FileUploadReqSchema: SchemaDefinition = {
  properties: {
    file: {
      description: '文件',
      format: '*ghttp.UploadFile',
      type: 'file',
      label: '文件',
    },
  },
  required: ['file'],
  type: 'object',
}
